import type { RefObject } from 'react';
import { useEffect } from 'react';
import { isEditableIndex } from '@alfa-bank/site-input/src/helpers';

import { setInputSelection } from './helpers';
import type { TMaskOptions } from './models';

export const useCursorPosition = (
    currentPosition: {
        end: number | null;
        start: number | null;
    },
    inputRef: RefObject<HTMLInputElement>,
    maskOptions: TMaskOptions,
    isDeleteOperation: boolean
) => {
    useEffect(() => {
        if (inputRef.current) {
            // возвращает курсор в нужное положение
            let { start: correctPosition } = currentPosition;

            const { selectionStart: defaultPosition } = inputRef.current;
            const { mask, permanents, prefix } = maskOptions;

            if (
                correctPosition &&
                defaultPosition &&
                correctPosition > 4 &&
                correctPosition < defaultPosition &&
                (isDeleteOperation ||
                    mask.length === defaultPosition ||
                    Math.abs(correctPosition - defaultPosition) > 1)
            ) {
                setInputSelection(inputRef.current, correctPosition);
            }

            if (defaultPosition && defaultPosition < prefix.length) {
                setInputSelection(inputRef.current, prefix.length);
            }

            while (
                correctPosition &&
                correctPosition !== prefix.length &&
                (correctPosition < prefix.length ||
                    (!isEditableIndex(correctPosition - 1, permanents) && !isDeleteOperation))
            ) {
                correctPosition += 1;
                setInputSelection(inputRef.current, correctPosition);
            }
        }
    }, [currentPosition, inputRef, isDeleteOperation, maskOptions]);
};
